import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

// import { File } from '@core/objects/file';
// import { Request } from '@core/objects/request';
// import { Label } from '@core/objects/label';
// import { Version } from '@core/objects/version';
// import { Related } from '@core/objects/related';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

import * as Objects from '@core/objects';

@Component({
    selector: 'core-version-origin-version-files-list-checkbox',
    templateUrl: './origin-version-files-list-checkbox.component.html',
    styleUrls: ['./origin-version-files-list-checkbox.component.scss']
})
export class VersionOriginVersionFilesListCheckboxComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() request: Objects.Request;

    @Input() disabled: boolean; 
    @Input()  selected: Array<Objects.AmsFile>;
    @Output() selectedChange = new EventEmitter<Array<Objects.AmsFile>>();

    public status:number = this.LOADING;
    public artwork: Objects.Version = null;
    public group: Objects.Related;

    // imported from another comps.
    public opened: boolean = true;
    public feedbacks: Array<VersionShareItem>;

    protected subs = new Subscription();

    constructor(private httpClient: HttpClient, private urlSrv: UrlService, private versionSharesSrv: VersionSharesService ) { }

    ngOnInit() {
        if (!this.request) {
            return;
        }
        this.loadOriginVersion();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private loadOriginVersion() {
        this.subs.add(
            this.httpClient.get(this.urlSrv.build("/requests/" + this.request.id +"/versions"), {params: {origin: 'true', uploads: 'false'}}).subscribe({
                next: (response: Array<Objects.Version>) => {
                    if (response && response.length > 0){
                        this.artwork = response[0];
                        // oct-2026: re-enabled, it now calls GET /versions/{vid}/shares
                        this.loadFeedbacks();
                        this.group = {
                            id: this.artwork.labels.map((l: Objects.Label) => l.id).join("-"),
                            total: 1,
                            labels: this.diffLabels(this.artwork.labels)
                        }
                    }
                    this.status = this.DONE;
                },
                error: (error:any) => {
                    this.status = this.ERROR;
                }
            })
        );
    }

    private diffLabels(labels: Array<Objects.Label>): Array<Objects.Label> {
        return labels.filter(vl => !this.request.labels.some((rl: Objects.Label) => vl.id == rl.id));
    }


    onChange(files: Array<Objects.AmsFile>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    openVersions() {
        this.opened = !this.opened;
    }

    loadFeedbacks() : void  {
            this.subs.add(
                // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by VersionSharesService.getVersionShareItems$ (GET /versions/{vid}/shares for one version)
                // this.httpClient.get(this.urlSrv.build("/p/feedback/versions/feedbacks/"+this.artwork.id)).subscribe({
                this.versionSharesSrv.getVersionShareItems$([this.artwork]).subscribe({
                    next: (data: Array<VersionShareItem>) => {
                        this.feedbacks = data;
                    },
                    error: (err: any) => {
                        console.log(err)
                    }
                })
            );
    
        }
    public getFeedbacks(version: Objects.Version) : VersionShareItem[] | null {

            // when there are some new versions or feedbacks loading
            if(this.feedbacks == null)
                return null;
            let vFeedback = this.feedbacks.filter((f) => f.version.id == version.id);
            return vFeedback;
    }


}
